import { API } from './interceptor'

export const notifyRestrictedSupplierPaywallSales = ({
  venueId,
  source = 'client',
  platform = 'dashboard',
  supplierTitle = null,
}) => {
  if (!venueId) {
    return Promise.resolve()
  }

  return API.post(
    'api2',
    `venue/${venueId}/restricted-supplier-paywall-notify`,
    {
      body: {
        source,
        platform,
        supplierTitle,
      },
    },
  ).catch(() => {
    // Fire-and-forget; paywall UX must not depend on sales notify
  })
}
